module.exports = __webpack_public_path__ + "img/undraw_Progress_indicator_re_4o4n.ff5572ce.svg";